import { useState } from 'react';
import { UseModalValue } from './useModal.types';

const useModal = (): UseModalValue => {
  const [isShowing, setIsShowing] = useState(false);

  const toggle = (): void => {
    setIsShowing((prev) => !prev);
  };

  const toggleAuto = (callbackFn?: Function): void => {
    setIsShowing(true);
    setTimeout(() => {
      setIsShowing(false);
      callbackFn?.();
    }, 2000);
  };

  return {
    isShowing,
    setIsShowing,
    toggle,
    toggleAuto,
  };
};

export default useModal;
